import React from 'react';
import { ChevronLeft, ChevronRight, CheckCircle } from 'lucide-react';

interface WizardFooterProps {
  pasoActual: number;
  totalPasos: number;
  esPrimerPaso: boolean;
  esUltimoPaso: boolean;
  loading: boolean;
  tieneDetalles: boolean;
  onAnterior: () => void;
  onSiguiente: () => void;
  onSubmit: () => void;
}

const WizardFooter: React.FC<WizardFooterProps> = ({
  pasoActual,
  totalPasos,
  esPrimerPaso,
  esUltimoPaso,
  loading,
  tieneDetalles,
  onAnterior,
  onSiguiente,
  onSubmit,
}) => {
  return (
    <div
      className="flex items-center justify-between p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900"
      role="navigation"
      aria-label="Navegación del wizard"
    >
      <button
        type="button"
        onClick={onAnterior}
        disabled={esPrimerPaso || loading}
        className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg
                   hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50
                   disabled:cursor-not-allowed flex items-center gap-2
                   text-gray-700 dark:text-gray-300"
        aria-label="Ir al paso anterior"
      >
        <ChevronLeft className="w-4 h-4" />
        Anterior
      </button>

      <div className="text-sm text-gray-600 dark:text-gray-400" aria-live="polite">
        Paso {pasoActual} de {totalPasos}
      </div>

      {!esUltimoPaso ? (
        <button
          type="button"
          onClick={onSiguiente}
          disabled={loading}
          className="px-6 py-2 bg-blue-600 dark:bg-blue-700 text-white rounded-lg
                     hover:bg-blue-700 dark:hover:bg-blue-600 flex items-center gap-2
                     disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Ir al siguiente paso"
        >
          Siguiente
          <ChevronRight className="w-4 h-4" />
        </button>
      ) : (
        <button
          type="button"
          onClick={onSubmit}
          disabled={loading || !tieneDetalles}
          className="px-6 py-2 bg-green-600 dark:bg-green-700 text-white rounded-lg
                     hover:bg-green-700 dark:hover:bg-green-600
                     disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          aria-label="Guardar factura"
        >
          {loading ? 'Guardando...' : 'Guardar Factura'}
          <CheckCircle className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};

export default WizardFooter;
